/**
 * Labstep
 *
 * @module components/Filter/Metadata
 * @desc Filter for Metadata
 */

import { FilterMetadataForm } from 'labstep-web/components/Filter/Metadata/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Metadata } from 'labstep-web/models/metadata';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { FilterMetadataProps } from './types';

const metadataNameCapitalised = Metadata.getHumanReadableEntityName(
  false,
  true,
);

export const FilterMetadata: React.FC<FilterMetadataProps> = ({
  entityName,
  childEntityName,
  addPostFilter,
  actionComponentProps,
  defaultValues,
  replace,
  addAnother,
  ...rest
}) => (
  <Modal
    header={`Filter by ${metadataNameCapitalised}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text={
          childEntityName
            ? `${getHumanReadableEntityName(
                childEntityName || entityName,
                false,
                true,
              )} ${metadataNameCapitalised}`
            : metadataNameCapitalised
        }
        {...actionComponentProps}
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterMetadataForm
        addPostFilter={addPostFilter}
        path={
          childEntityName === 'resource'
            ? 'resource.metadatas'
            : 'metadatas'
        }
        onDone={toggleModal}
        defaultValues={defaultValues}
        replace={replace}
        addAnother={addAnother}
      />
    )}
    {...rest}
  />
);
